module.exports = __webpack_public_path__ + "static/media/Josh-Carter.f17e0dbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/social/Josh-Carter.jpg
// module id = 377
// module chunks = 0